<template>
  <div>
    <Header />

    <!-- 毛毛蟲 -->
    <nav aria-label="breadcrumb" class="breadcrumb_box">
      <div class="container">
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <router-link to="/Profile" title="首頁">Home</router-link>
          </li>
          <li class="breadcrumb-item active" aria-current="page">Disclaimer</li>
        </ol>
      </div>
    </nav>

    <div class="main form disclaimer">
      <a accesskey="c" class="accesskey" id="accesskey_c" href="javascript:void(0);" title="中央內容區塊"
        onclick="document.getElementById('accesskey_c').scrollIntoView();">
        :::
      </a>

      <div class="container">
        <div class="box">
          <div class="title">
            <h2>Disclaimer / Personal Information Protection</h2>
          </div>

          <!-- Loading state -->
          <div v-if="isLoading" class="bg">
            <div class="text_box">
              <p>Loading terms and conditions...</p>
            </div>
          </div>

          <!-- No active period message -->
          <div v-else-if="!hasActivePeriod" class="bg">
            <div class="text_box">
              <p>There is no active application period at this time.</p>
            </div>
          </div>

          <!-- Dynamic terms from API -->
          <template v-else>
            <div class="bg" v-for="(term, index) in terms" :key="index">
              <div class="title_box description">
                <h3>{{ term.Title }}</h3>
              </div>

              <div class="text_box" v-html="term.Content"></div>
            </div>

            <div class="btn_box">
              <button class="btn" @click="gotoApply">Agree</button>
              <button class="btn" @click="gotoProfile">Disagree</button>
            </div>
          </template>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>
<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import { mapActions } from 'vuex';
import Swal from 'sweetalert2';
import authService from '@/services/auth';

export default {
  name: "Terms",
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      isLoading: true,
      hasActivePeriod: false,
      terms: [],
    };
  },

  async mounted() {
    window.scrollTo(0, 0);
    await this.loadTerms();
  },

  methods: {
    ...mapActions(['checkActiveApplyPeriod', 'getActiveApplyTerms']),

    async loadTerms() {
      try {
        this.isLoading = true;

        // 1. 檢查是否有進行中的學期梯次
        const periodResult = await this.checkActiveApplyPeriod();

        if (!periodResult.success) {
          // API 呼叫失敗
          await Swal.fire({
            icon: 'error',
            title: 'Error',
            text: periodResult.message || 'Failed to check active apply period',
            confirmButtonColor: '#4d167d',
          });
          this.hasActivePeriod = false;
          this.isLoading = false;
          return;
        }

        // 假設 API 回傳格式為 { hasActivePeriod: true/false }
        // 根據實際 API 回傳格式調整
        this.hasActivePeriod = periodResult.data?.hasActiveApply;

        if (!this.hasActivePeriod) {
          this.isLoading = false;
          return;
        }

        // 2. 取得進行中的學期梯次的條款
        const termsResult = await this.getActiveApplyTerms();

        if (!termsResult.success) {
          await Swal.fire({
            icon: 'error',
            title: 'Error',
            text: termsResult.message || 'Failed to load terms and conditions',
            confirmButtonColor: '#4d167d',
          });
          this.isLoading = false;
          return;
        }

        // 解析條款資料
        if (termsResult.data?.termsAndConditions) {
          // 如果 API 回傳的是 JSON 字串，需要解析
          if (typeof termsResult.data?.termsAndConditions === 'string') {
            try {
              this.terms = JSON.parse(termsResult.data?.termsAndConditions);
            } catch (e) {
              console.error('Failed to parse terms JSON:', e);
              this.terms = [];
            }
          } else if (Array.isArray(termsResult.data?.termsAndConditions)) {
            // 如果已經是陣列，直接使用
            this.terms = termsResult.data?.termsAndConditions;
          } else {
            this.terms = [];
          }
        }

      } catch (error) {
        console.error('Error loading terms:', error);
        await Swal.fire({
          icon: 'error',
          title: 'Unexpected Error',
          text: 'An unexpected error occurred while loading terms',
          confirmButtonColor: '#4d167d',
        });
      } finally {
        this.isLoading = false;
      }
    },

    async gotoApply() {
      await authService.updateAgree(1);
      this.$router.push("/Apply/1").then(() => {
        window.scrollTo(0, 0); // 滾到最上面
      });
    },
    
    async gotoProfile() {
      await authService.updateAgree(2);
      this.$router.push("/Profile").then(() => {
        window.scrollTo(0, 0); // 滾到最上面
      });
    },
  },
};
</script>
